import { useCallback } from "react";
import { useDispatch } from "react-redux";
import { TooltipHost, TooltipOverflowMode } from "@fluentui/react/lib/Tooltip";
import { LinkWithTooltip } from "Components/Generic/LinkWithTooltip";
import {
  Tile, TileBody, TileFooter, TileHeader
} from "Components/Generic/Tile";
import { getAddress, getLine2 } from "Utils/Address";
import { uiSetActiveCompanyId } from "Store/Actions";
import { CompanyActions } from "./CompanyActions";
import { CompanyContacts } from "./CompanyContacts";
import { ITileProps } from "../ITileProps";

export function CompanyTile(props: ITileProps): JSX.Element {
  const { item } = props;
  const dispatch = useDispatch();

  const onClick = useCallback(() => {
    dispatch(uiSetActiveCompanyId(item[`@id`]));
  }, [item, dispatch]);

  return (
    <Tile>
      <TileHeader>
        <LinkWithTooltip item={item} onClick={onClick} />
      </TileHeader>
      <TileHeader asSubHeader>
        <TooltipHost overflowMode={TooltipOverflowMode.Parent} content={getAddress(item)}>
          {getAddress(item)}
        </TooltipHost>
      </TileHeader>
      <TileHeader asSubHeader>
        <TooltipHost overflowMode={TooltipOverflowMode.Parent} content={getLine2(item)}>
          {getLine2(item)}
        </TooltipHost>
      </TileHeader>
      <TileBody>
        <CompanyContacts company={item} />
      </TileBody>
      <TileFooter>
        <CompanyActions company={item} />
      </TileFooter>
    </Tile>
  );
}
